import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Typography} from 'antd'

import {productService} from 'services'
import requestHandler from 'utils/requestHandler'
import priceParser from 'utils/priceParser'
import {ShopIcon} from 'components/CustomIcons'
import useCartContext from 'components/Cart/useCartContext'
import BBreadcrumb from 'components/BBreadcrumb'
import BButton from 'components/Form/Fields/BButton'
import ProductsSlider from 'components/Landing/ProductsSlider'
import ImagesView from 'modules/ProductDetailPage/ImagesView'
import DetailSteps from 'modules/ProductDetailPage/DetailSteps'

const ProductDetailPage = ({match: {params: {ean, merchantUuid, externalId}}}) => {
  const {t} = useTranslation()
  const {cart, cartDispatch} = useCartContext()
  const [productData, setProduct] = useState(undefined)

  useEffect(() => {
    setProduct(undefined)

    requestHandler(() => productService.detail(ean, merchantUuid, externalId), 'json')
      .then(r => {
        if (r.success) {
          setProduct(r.data)
        } else {
          setProduct(null)
        }
      })
  }, [ean, merchantUuid, externalId])

  const cartAdd = e => {
    e.preventDefault()
    cartDispatch({
      type: 'add',
      payload: {
        item: {
          uuid: productData.productMeta.product.uuid,
          price: 4242,
          quantity: 1,
          itemId: ean ?? externalId,
          itemIdType: ean ? 'ean' : 'external',
          metaProduct: {...productData.productMeta},
        },
      },
    })
  }

  const cartRemove = e => {
    e.preventDefault()
    cartDispatch({type: 'remove', payload: productData.productMeta.product.uuid})
  }

  const cartIncrement = e => {
    e.preventDefault()
    cartDispatch({type: 'increment', payload: {uuid: productData.productMeta.product.uuid, amount: 1}})
  }

  const cartDecrement = e => {
    e.preventDefault()
    cartDispatch({type: 'decrement', payload: {uuid: productData.productMeta.product.uuid, amount: 1}})
  }

  return (
    <div className='productDetail'>
      {productData ? (
        <>
          <BBreadcrumb product={productData.productMeta.product} categories={productData.category}/>

          <div className='productDetail-main'>
            <ImagesView data={productData.productMeta.product}/>

            <div>
              <h4>{productData.productMeta.product.name}</h4>
              <h5>{ean ?? externalId}</h5>
              <Typography.Paragraph ellipsis={{rows: 2, expandable: true}}>{productData.productMeta.product.description}</Typography.Paragraph>
              <p className='productDetail-price'>
                {ean ? (
                  <>{t('from')} <span>{priceParser(productData.productMeta.fromPrice)}</span></>
                ) : (
                  <span>{priceParser(productData.productMeta.fromPrice)}</span>
                )} ({t('Inc. VAT')})
              </p>
              {/* <Popover content={product.merchant.map(e => e.uuid)'}>{console.log(product.merchant.length)} stores</Popover> */}

              {cart.items[productData.productMeta.product.uuid] ? (
                <>
                  <button onClick={cartRemove}>remove from cart</button>
                  <button onClick={cartIncrement}>+</button>
                  {cart.items[productData.productMeta.product.uuid].quantity}
                  <button onClick={cartDecrement}>-</button>
                </>
              ) : (
                <BButton bordered onClick={cartAdd}><ShopIcon/> BUY NOW</BButton>
              )}
            </div>
          </div>

          <DetailSteps data={productData} t={t}/>

          <ProductsSlider
            Title={<h1>{t('Customers also shopped for')}</h1>}
            data={[]}
          />

          <ProductsSlider
            Title={<h1>{t('Similar Products in Category')}</h1>}
            data={[]}
          />
        </>
      ) : productData === undefined ? (
        'loading...'
      ) : (
        'error'
      )}
    </div>
  )
}

export default ProductDetailPage
